export { default as MaterialOutlineIcon } from './MaterialOutlineIcon';
